import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const SiteCtx = createContext({ settings: {} });

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState({});
  useEffect(() => {
    api
      .get("/settings/public")
      .then((r) => setSettings(r.data || {}))
      .catch(() => {});
  }, []);
  return <SiteCtx.Provider value={{ settings }}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);

